import { IAppRouteProps } from "ui/app/navigation";
import { IAuthorizationData } from "ui/app/user-provider";

import { IMenuItem, IMenuItems } from "./TopNavigationMenu";

const adjustGroupMenuItemSecurity = (groupMenuItem: IMenuItem, requiredAuthorizationData: IAuthorizationData[] = []) => {
  if (groupMenuItem.requiredAuthorizationData) {
    groupMenuItem.requiredAuthorizationData = [...groupMenuItem.requiredAuthorizationData, ...requiredAuthorizationData];
  }
};

const createMenuItems = (item: IAppRouteProps, result: IMenuItems) => {
  const path = item.path ? (typeof item.path === "string" ? item.path : item.path.length ? item.path[0] : "") : "";
  const newItem: IMenuItem = {
    id: item.id,
    icon: item.icon,
    title: item.title,
    path: path,
    requiredAuthorizationData: item.requiredAuthorizationData,
    children: []
  };

  result.planeList.push(newItem);

  if (item.group) {
    const group = item.group;

    const existingGroupMenuItem = result.planeList.filter(e => e.id === group.id)[0];

    if (existingGroupMenuItem) {
      adjustGroupMenuItemSecurity(existingGroupMenuItem, item.requiredAuthorizationData);
      existingGroupMenuItem.children.push(newItem);
    } else {
      const groupMenuItem: IMenuItem = {
        id: group.id,
        icon: group.icon,
        title: group.title,
        path: "",
        requiredAuthorizationData: item.requiredAuthorizationData,
        children: [newItem],
        isGroup: true
      };

      result.planeList.push(groupMenuItem);
      result.groupedList.push(groupMenuItem);
    }
  }
};

export const getMenuItems = (appRoutes: IAppRouteProps[]): IMenuItems => {
  const result: IMenuItems = {
    planeList: [],
    groupedList: []
  };

  for (const route of appRoutes.filter(e => e.showInMainMenu)) {
    createMenuItems(route, result);
  }

  return result;
};
